import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'

Vue.use(VueI18n)
Vue.use(VueCookies)

const requireLangueages = require.context('.', true, /lang.js*$/)
const languagesUnparsed = []
const messages = {}
const locale = Vue.$cookies.get('locale') || 'en_US'

requireLangueages.keys().forEach(key => {
  languagesUnparsed.push(requireLangueages(key))
})

languagesUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    messages[key] = el[key]
  })
})

export const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'en_US'
})
